import { isNodeList } from "./isNodeList.js";

export function removeAttrs(els, attrs) {
  els = (isNodeList(els) || els instanceof Array) ? els : [els];
  attrs = (attrs instanceof Array) ? attrs : [attrs];

  var attrLength = attrs.length;
  for (var i = els.length; i--;) {
    for (var j = attrLength; j--;) {
      els[i].removeAttribute(attrs[j]);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/removeAttrs.js
// module id = 861
// module chunks = 2